module.exports = __webpack_public_path__ + "static/sk-white-3a0110955652f1ff905fab81ceb947ad.png";